import { useMobile } from '../../../../../../../common/services/screenSize/ScreenSizeService';
import { isNonEmpty } from '../../../../../../../common/util/arrays/NonEmpty';
import { Collapsing, More, Value } from './CollapsingValue.styles';
import { summarise } from './summarise';

const DESKTOP_STRING_LENGTH = 40;
const MOBILE_STRING_LENGTH = 22;

interface Props {
  values: string[];
}

export const CollapsingValue = ({ values }: Props) => {
  const mobile = useMobile();

  const maxLength = mobile ? MOBILE_STRING_LENGTH : DESKTOP_STRING_LENGTH;

  if (!isNonEmpty(values)) {
    return null;
  }

  const { display, more } = summarise(values, maxLength);

  return (
    <Collapsing>
      <Value>{display}</Value>
      {more > 0 && <More>(+{more})</More>}
    </Collapsing>
  );
};
